module.exports = __webpack_public_path__ + "static/media/brand.312eaf79.png";